import usePrivateAxios from '@/common/api/usePrivateAxios';
import { defaultMeta } from '@/common/constants/defaultMeta.constant';
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { PaginationMeta, TmaisBannerData, TmaisBannersIndexResponse } from '@/features/tmaisBanners/types/tmaisBanner.type';

export type UseTmaisBannersProps<T> = {
  filters?: {
    search?: string;
    page?: number;
  };
  enabled?: boolean;
  mapper?: (data: TmaisBannerData[]) => T;
};

export const useTmaisBanners = <T = TmaisBannerData[]>({
  filters: { search = '', page } = {},
   mapper = ((data: TmaisBannerData[]) => data as unknown as T) as any,
  enabled,
}: UseTmaisBannersProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['tmaisBanners', search, page],
    queryFn: () =>
      privateAxios.get('/tmais/banners', {
        params: {
          search,
          page,
        },
      }),
    select: (response: TmaisBannersIndexResponse) => ({
      data: mapper(response?.data?.data || []),
      meta: (response?.data?.meta || defaultMeta) as PaginationMeta,
    }),
    placeholderData: keepPreviousData,
    enabled,
  });

  return { data, meta, isPending, ...rest };
};
